<template>
  <div class="hello">
    <div class="title1">欢迎使用</div>
    <div class="box-button">
    <div class="button" @click="themebutton">钉钉绑定</div>
     <a
          :href="
            'http://wxapp.lny119.com'
          "
          target="_blank"
          class="cajieneng ca"

        ><div class="button" >119平台</div>
        </a>
    </div>

  </div>
</template>
<script>
import { MessageBox } from "mint-ui";
export default {
  name: "bindDetail",
  data() {
    return {

    };
  },
  mounted() {
    this.request.openId = this.$route.query.openId;
    if (this.request.openId) {
      this.getUserInfo();
    }
  },
  methods: {
    themebuttonPI(){
      var _t=this;
      _t.$router.push({
                path: "http://wxapp.lny119.com",

          });

    },
    themebutton(){
      var _t=this;
      _t.$router.push({
                path: "/ddbindDetail",
          });

    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.bindIsOk,
        { openId: this.request.openId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user = res.data;
            _t.request.phone = res.data.userphone;
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId,
            };
            _t.$router.push({
              path: "/bindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
      this.isShow = true;
    },
    unbindWeChat() {
      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then((action) => {
          _t.common.doActionGet(
            _t.common.removeBindLny,
            _t.request,
            function (res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId,
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query,
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
  margin-top: -40px;
}
.title1 {
  font-size: 40px;
}
.button{
  border: 1px solid;
    width: 150px;
    border-radius: 10px;
    margin-top: 20px;
}
.box-button{
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 30px;
}
a:link{		/*默认状态*/
        color: black;

        text-decoration:none;
    }
    a:visited{	/*浏览过的*/
        color:black;

        text-decoration:none;
    }
    a:hover{	/*悬浮状态*/
        color:black;

        text-decoration:none;
    }
    a:active{	/*激活过的*/
        color: black;

        text-decoration:none;
    }
</style>



// WEBPACK FOOTER //
// src/components/dd/ddhome.vue